import {
  ThgAddressWithGeoDocumentGen,
  ThgChargingPointGen,
  ThgChargingPointOperatorGen,
  ThgCreateChargingStationDtoGen
} from "@/services/thg/v1/data-contracts";

/**
 * @inheritdoc
 */
export class CreateChargingStation implements ThgCreateChargingStationDtoGen {
  /**
   * @inheritdoc
   */
  name: string;

  /**
   * @inheritdoc
   */
  chargingPointOperator: ThgChargingPointOperatorGen;

  /**
   * Indicates if charging station has been registered at BNetz-A
   */
  isRegistered = true;

  /**
   * @inheritdoc
   */
  address: ThgAddressWithGeoDocumentGen;

  /**
   * @inheritdoc
   */
  commissioningDate: string;

  /**
   * @inheritdoc
   */
  connectionPowerInKwh: number;

  /**
   * @inheritdoc
   */
  chargingPointCount: number;

  /**
   * @inheritdoc
   */
  chargingPoints: ThgChargingPointGen[];

  /**
   * @inheritdoc
   */
  isPublic?: boolean;

  /**
   * @inheritdoc
   */
  evseId?: string;

  /**
   * @inheritdoc
   */
  meLoId?: string;

  /**
   * @inheritdoc
   */
  maLoId?: string;

  /**
   *
   */
  constructor() {
    this.name = "";
    this.chargingPointOperator = {
      name: "",
      address: {
        street: "",
        zip: "",
        city: "",
        state: "Deutschland"
      }
    };

    this.address = {
      street: "",
      zip: "",
      city: "",
      state: "Deutschland",
      geo: {
        lat: 0,
        lng: 0
      }
    };
    this.commissioningDate = "";
    this.connectionPowerInKwh = 22;
    this.chargingPointCount = 1;
    this.chargingPoints = [];
  }
}
